<style lang="scss" scoped>
.partner-wrapper{
  margin-top: 118px;
  &-content{
    margin-top: 65px;
    height: 176px;
    ul{
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 50px;
      box-sizing: border-box;
      li{
        width:218px;
        height:148px;
        background:rgba(24,66,127,1);
        border-radius:12px;
        // opacity:0.8105;
        // cursor: pointer;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>

<template>
  <div v-if="partnerData" class="partner-wrapper">
    <div class="wrapper-reset">
      <Title title="合作伙伴"></Title>
      <div class="partner-wrapper-content">
        <ul>
          <li v-for="item in partnerData" @click="openLink(item.link)" :style="{'cursor': item.link ? 'pointer' : ''}">
            <img :src="item.cover" alt="">
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/Title';
export default {
  components: {
    Title,
  },
  data() {
    return{
      partnerData: {}
    }
  },
  mounted() {
    this.$bus.on('partnerData', (data) => {
      this.partnerData = data.itemList;
    });
  },
  methods: {
    openLink(link) {
      if(link){
        window.open(link);
      } else {
        return false;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/blocks/Partner.vue